module.exports = __webpack_public_path__ + "8b1cb19de8143cf58182826bbb474bce.fbx";